import {useState, useCallback, useEffect, useContext} from "react";
import {useApi} from "@buildwitt/shapeshift-identity";
import {AuthContext} from "@buildwitt/shapeshift-identity";

interface CourseSearchParams {
	page: number;
	searchTerm: string;
	pageSize?: number;
}

interface UseCourseSearchResult {
	courseData: any | null;
	apiResult: {
		isLoading: boolean;
		isError: boolean;
		error?: any;
	};
	getCourseSearchData: (params: CourseSearchParams) => Promise<void>;
}

const useCourseSearch = (): UseCourseSearchResult => {
	const [courseData, setCourseData] = useState<any | null>(null);
	const [apiResponse, submitApiCall] = useApi<any>();
	const {jwt} = useContext(AuthContext);

	const getCourseSearchData = useCallback(async ({
		page,
		searchTerm,
		pageSize = 100
	}: CourseSearchParams) => {
		submitApiCall({
			url: "/api/v1/course/search",
			method: "GET",
			config: {
				params: {
					page: page.toString(),
					pageSize: pageSize.toString(),
					search: searchTerm
				},
				headers: {
					"Content-Type": "application/json",
					"Authorization": `Bearer ${jwt}`
				}
			}
		});
	}, [submitApiCall, jwt]);

	useEffect(() => {
		if (apiResponse.statusCode === 200 && apiResponse.data) {
			// Replace the data with the latest response
			setCourseData(apiResponse.data);
		} else if (apiResponse.statusCode && apiResponse.statusCode !== 200) {
			setCourseData(null);
		}
	}, [apiResponse]);

	return {
		courseData,
		apiResult: {
			isLoading: apiResponse.isLoading,
			isError: apiResponse.isError,
			error: apiResponse.errorData
		},
		getCourseSearchData
	};
};

export default useCourseSearch;
